import { Title, AttributesList } from '@tecton';
import React from 'react';
import { DataSourceDetailsPanelData } from './detailsPanelQueryTypes';
import { DataFlowSidePanel, DescriptionSection } from './StyledPanelComponents';
import DetailsPanelAccordionSection from './DetailsPanelAccordionSection';

const RawStreamSourceContextPanel = ({
  id,
  name,
  sourceType,
  detailsPanelClearAll,
  zoomToNode,
  data,
}: {
  id: string;
  name: string;
  sourceType: string;
  detailsPanelClearAll: () => void;
  zoomToNode?: () => void;
  data?: DataSourceDetailsPanelData;
}) => {
  return (
    <DataFlowSidePanel
      name={name}
      prehead={sourceType}
      nodeId={id}
      detailsPanelClearAll={detailsPanelClearAll}
      zoomToNode={zoomToNode}
    >
      {data && (
        <>
          <DescriptionSection description={`Stream source used in the ${data.name} data source.`} />

          <DetailsPanelAccordionSection
            id="output-features"
            title={
              <Title size="xxs">
                <h4>{sourceType} Configurations</h4>
              </Title>
            }
          >
            {data.streamConfig && data.streamConfig.properties.length > 0 ? (
              <AttributesList
                compressed
                listItems={data.streamConfig.properties.map(({ name, value }) => {
                  return {
                    title: name,
                    description: value || 'n/a',
                  };
                })}
              />
            ) : (
              <p>No Configurations</p>
            )}
          </DetailsPanelAccordionSection>
        </>
      )}
    </DataFlowSidePanel>
  );
};

export default RawStreamSourceContextPanel;
